class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    this.initializeQuantityButtons();
  }

  initializeQuantityButtons() {
    this.querySelectorAll('.cart-quantity').forEach((container) => {
      const minusBtn = container.querySelector('.quantity__button--minus');
      const plusBtn = container.querySelector('.quantity__button--plus');
      const input = container.querySelector('.quantity__input');

      if (minusBtn && plusBtn && input) {
        const min = parseInt(input.dataset.min) || 0; // 0 yapıyoruz ki 1'den aşağıya inebilsin
        const max = parseInt(input.dataset.max) || 999;
        const available = parseInt(input.dataset.available) || max;

        minusBtn.addEventListener('click', () => {
          const currentValue = parseInt(input.value);
          const step = parseInt(input.dataset.step) || 1;

          // Eğer mevcut değer 1 ise ve eksi butonuna tıklanırsa, ürünü sil
          if (currentValue === 1) {
            this.removeItem(input.dataset.index, input.dataset.quantityVariantId);
          } else if (currentValue > min) {
            input.value = currentValue - step;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          this.updateButtonStates(minusBtn, plusBtn, input, min, available, max);
        });

        plusBtn.addEventListener('click', () => {
          const currentValue = parseInt(input.value);
          const step = parseInt(input.dataset.step) || 1;
          if (currentValue < available && currentValue < max) {
            input.value = currentValue + step;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          this.updateButtonStates(minusBtn, plusBtn, input, min, available, max);
        });

        input.addEventListener('change', () => {
          this.updateButtonStates(minusBtn, plusBtn, input, min, available, max);
        });

        this.updateButtonStates(minusBtn, plusBtn, input, min, available, max);
      }
    });
  }

  updateButtonStates(minusBtn, plusBtn, input, min, available, max) {
    const currentValue = parseInt(input.value);
    minusBtn.disabled = false;
    minusBtn.classList.toggle('quantity__button--disabled', currentValue <= min);

    plusBtn.disabled = currentValue >= available || currentValue >= max;
    plusBtn.classList.toggle('quantity__button--disabled', plusBtn.disabled);
  }

  removeItem(line, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity: 0,
      sections: this.getSectionsToRender()
        .map((section) => section.section)
        .filter(Boolean),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (!sectionElement) return;

          const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
          if (elementToReplace && parsedState.sections[section.section]) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        this.updateCartIconBubble(parsedState.item_count);

        if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) {
          errors.textContent =
            window.cartStrings?.error || 'There was an error while updating your cart. Please try again.';
        }
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.cartData && event.cartData.item_count !== undefined) {
        this.updateCartIconBubble(event.cartData.item_count);
      } else {
        this.fetchCartAndUpdateBubble();
      }

      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  fetchCartAndUpdateBubble() {
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        this.updateCartIconBubble(cart.item_count);
      })
      .catch((error) => {
        console.error('Error fetching cart:', error);
      });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input =
      this.querySelector(`#Quantity-${id}`) ||
      this.querySelector(`#Drawer-quantity-${id}`) ||
      this.querySelector(`[data-index="${id}"] .quantity__input`);

    if (input) {
      input.value = input.getAttribute('value');
      this.isEnterPressed = false;
    }
  }

  setValidity(event, index, message) {
    if (!event.target) return;

    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    if (event.target.select) event.target.select();
  }

  validateQuantity(event) {
    if (!event.target) return;

    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (!index) {
      console.error('Index not found in event target:', event.target);
      return;
    }

    let message = '';

    if (inputValue < event.target.dataset.min) {
      message =
        window.quickOrderListStrings?.min_error?.replace('[min]', event.target.dataset.min) ||
        `Minimum ${event.target.dataset.min} required`;
    } else if (inputValue > parseInt(event.target.max)) {
      message =
        window.quickOrderListStrings?.max_error?.replace('[max]', event.target.max) ||
        `Maximum ${event.target.max} allowed`;
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message =
        window.quickOrderListStrings?.step_error?.replace('[step]', event.target.step) ||
        `Must be in increments of ${event.target.step}`;
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      const name = document.activeElement?.getAttribute('name') || 'quantity';
      this.updateQuantity(index, inputValue, event, name, event.target.dataset.quantityVariantId);
    }
  }

  onChange(event) {
    if (event.target.classList.contains('quantity__input')) {
      this.validateQuantity(event);
    }
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
          this.initializeQuantityButtons();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    if (quantity === 0) {
      this.removeItem(line, variantId);
      return;
    }

    const eventTarget = event?.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';
    const cartPerformanceUpdateMarker = CartPerformance.createStartingMarker(`${eventTarget}:user-action`);

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender()
        .map((section) => section.section)
        .filter(Boolean),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            if (quantityElement) {
              quantityElement.value = quantityElement.getAttribute('value');
            }
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const sectionElement = document.getElementById(section.id);
            if (!sectionElement) return;

            const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          });

          this.updateCartIconBubble(parsedState.item_count);
          this.initializeQuantityButtons();

          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (
            items.length === parsedState.items.length &&
            quantityElement &&
            updatedValue !== parseInt(quantityElement.value)
          ) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings?.error || 'There was an error while updating your cart. Please try again.';
            } else {
              message =
                window.cartStrings?.quantityError?.replace('[quantity]', updatedValue) ||
                `Only ${updatedValue} available`;
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) {
          errors.textContent =
            window.cartStrings?.error || 'There was an error while updating your cart. Please try again.';
        }
      })
      .finally(() => {
        this.disableLoading(line);
        CartPerformance.measureFromMarker(`${eventTarget}:user-action`, cartPerformanceUpdateMarker);
      });
  }

  updateCartIconBubble(itemCount) {
    document.querySelectorAll('.cart-count-bubble, .cart-bubble__text-count, .cart-bubble__count').forEach((bubble) => {
      if (bubble.classList.contains('cart-bubble__text-count')) {
        const limit = 99;
        if (itemCount > limit) {
          bubble.textContent = '99+';
        } else {
          bubble.textContent = itemCount;
        }
        if (itemCount === 0) {
          bubble.classList.add('hidden');
          const cartBubble = bubble.closest('.cart-bubble');
          if (cartBubble) {
            cartBubble.classList.add('visually-hidden');
          }
        } else {
          bubble.classList.remove('hidden');
          const cartBubble = bubble.closest('.cart-bubble');
          if (cartBubble) {
            cartBubble.classList.remove('visually-hidden');
          }
        }
      } else {
        bubble.textContent = itemCount;
        bubble.style.display = itemCount > 0 ? 'flex' : 'none';
      }
    });

    document.querySelectorAll('.cart-bubble').forEach((cartBubble) => {
      if (itemCount === 0) {
        cartBubble.classList.add('visually-hidden');
      } else {
        cartBubble.classList.remove('visually-hidden');
      }
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      const errorText = lineItemError.querySelector('.cart-item__error-text');
      if (errorText) {
        errorText.textContent = message;
      }
    }

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const selectedElement = parsedHtml.querySelector(selector);
    return selectedElement ? selectedElement.innerHTML : '';
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => {
      if (overlay) overlay.classList.remove('hidden');
    });

    if (document.activeElement) document.activeElement.blur();
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => {
      if (overlay) overlay.classList.add('hidden');
    });
    cartDrawerItemElements.forEach((overlay) => {
      if (overlay) overlay.classList.add('hidden');
    });
  }
}

customElements.define('cart-items', CartItems);

// Cart Note Custom Element
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.trigger = this.querySelector('.cart-note-trigger');
      this.overlay = this.querySelector('.cart-note-overlay');
      this.modal = this.querySelector('.cart-note-modal');
      this.closeBtn = this.querySelector('.cart-note-modal__close');
      this.applyBtn = this.querySelector('.cart-note-apply');
      this.cancelBtn = this.querySelector('.cart-note-cancel');
      this.textarea = this.querySelector('textarea');

      this.currentNoteValue = '';

      this.init();
    }

    init() {
      this.bindEvents();

      if (this.textarea) {
        this.textarea.addEventListener(
          'input',
          this.debounce((event) => {
            this.updateCartNote(event.target.value);
          }, 300)
        );
      }
    }

    bindEvents() {
      // Modal events
      this.trigger?.addEventListener('click', this.openModal.bind(this));
      this.closeBtn?.addEventListener('click', this.cancelAndClose.bind(this));
      this.applyBtn?.addEventListener('click', this.applyAndClose.bind(this));
      this.cancelBtn?.addEventListener('click', this.cancelAndClose.bind(this));
      this.overlay?.addEventListener('click', this.cancelAndClose.bind(this));

      // ESC key event
      document.addEventListener('keydown', this.handleKeydown.bind(this));

      // Prevent modal click propagation
      this.modal?.addEventListener('click', (e) => e.stopPropagation());
    }

    openModal() {
      this.currentNoteValue = this.textarea ? this.textarea.value : '';

      this.overlay?.classList.add('active');
      this.modal?.classList.add('active');
      this.modal?.setAttribute('aria-hidden', 'false');
      this.trigger?.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';

      if (this.textarea) {
        this.textarea.focus();
      }
    }

    closeModal() {
      this.overlay?.classList.remove('active');
      this.modal?.classList.remove('active');
      this.modal?.setAttribute('aria-hidden', 'true');
      this.trigger?.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    applyAndClose() {
      this.closeModal();
    }

    cancelAndClose() {
      if (this.textarea) {
        this.textarea.value = this.currentNoteValue;

        if (this.currentNoteValue !== this.textarea.value) {
          this.updateCartNote(this.currentNoteValue);
        }
      }

      this.closeModal();
    }

    handleKeydown(e) {
      if (e.key === 'Escape' && this.modal?.classList.contains('active')) {
        this.cancelAndClose();
      }
    }

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    updateCartNote(note) {
      const body = JSON.stringify({ note: note });
      fetch(`${window.routes?.cart_update_url || '/cart/update.js'}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: body,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Cart note updated');
          if (window.CartPerformance) {
            window.CartPerformance.measure('note-update:user-action');
          }
        })
        .catch((error) => {
          console.error('Error updating cart note:', error);
        });
    }
  }
  customElements.define('cart-note', CartNote);
}

// Shipping Calculator Custom Element
if (!customElements.get('shipping-calculator')) {
  class ShippingCalculator extends HTMLElement {
    constructor() {
      super();

      this.trigger = this.querySelector('.shipping-calculator-trigger');
      this.overlay = this.querySelector('.shipping-calculator-overlay');
      this.modal = this.querySelector('.shipping-calculator-modal');
      this.closeBtn = this.querySelector('.shipping-calculator-modal__close');
      this.cancelBtn = this.querySelector('.shipping-calculator-cancel');
      this.submitBtn = this.querySelector('.shipping-calculator__submit');
      this.countrySelect = this.querySelector('#ShippingCountry');
      this.provinceSelect = this.querySelector('#ShippingProvince');
      this.provinceContainer = this.querySelector('#ShippingProvinceContainer');
      this.zipInput = this.querySelector('#ShippingZip');
      this.responseElement = this.querySelector('#ShippingCalculatorResponse');

      this.init();
    }

    init() {
      this.bindEvents();
      this.initCountryProvinceSelector();
    }

    bindEvents() {
      // Modal events
      this.trigger?.addEventListener('click', this.openModal.bind(this));
      this.closeBtn?.addEventListener('click', this.closeModal.bind(this));
      this.cancelBtn?.addEventListener('click', this.closeModal.bind(this));
      this.overlay?.addEventListener('click', this.closeModal.bind(this));

      // Form events
      this.submitBtn?.addEventListener('click', this.calculateShipping.bind(this));
      this.zipInput?.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.calculateShipping();
        }
      });

      // Country change event
      this.countrySelect?.addEventListener('change', this.handleCountryChange.bind(this));

      // ESC key
      document.addEventListener('keydown', this.handleKeydown.bind(this));

      // Prevent modal click propagation
      this.modal?.addEventListener('click', (e) => e.stopPropagation());
    }

    openModal() {
      this.overlay?.classList.add('active');
      this.modal?.classList.add('active');
      this.modal?.setAttribute('aria-hidden', 'false');
      this.trigger?.setAttribute('aria-expanded', 'true');
    }

    closeModal() {
      this.overlay?.classList.remove('active');
      this.modal?.classList.remove('active');
      this.modal?.setAttribute('aria-hidden', 'true');
      this.trigger?.setAttribute('aria-expanded', 'false');
    }

    handleKeydown(e) {
      if (e.key === 'Escape' && this.modal?.classList.contains('active')) {
        this.closeModal();
      }
    }

    initCountryProvinceSelector() {
      if (this.countrySelect && this.provinceSelect) {
        // Shopify'ın province selector'ını başlat
        if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
          new Shopify.CountryProvinceSelector('ShippingCountry', 'ShippingProvince', {
            hideElement: 'ShippingProvinceContainer',
          });
        }
      }
    }

    handleCountryChange() {
      const country = this.countrySelect?.value;

      if (country && this.provinceSelect && typeof Shopify !== 'undefined') {
        Shopify.updateProvinceSelector(country, this.provinceSelect);

        if (
          Shopify.CountryProvinceSelector.countries[country] &&
          Shopify.CountryProvinceSelector.countries[country].length
        ) {
          this.provinceContainer.style.display = 'block';
        } else {
          this.provinceContainer.style.display = 'none';
        }
      }
    }

    calculateShipping() {
      const country = this.countrySelect?.value;
      const province = this.provinceSelect?.value;
      const zip = this.zipInput?.value;

      if (!country || !zip) {
        this.showResponse('Please fill in all required fields.', 'error');
        return;
      }

      this.setLoadingState(true);

      const data = {
        shipping_address: {
          country: country,
          province: province,
          zip: zip,
        },
      };

      fetch('/cart/shipping_rates.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          this.handleShippingResponse(data);
        })
        .catch((error) => {
          console.error('Error calculating shipping:', error);
          this.showResponse('Error calculating shipping. Please try again.', 'error');
        })
        .finally(() => {
          this.setLoadingState(false);
        });
    }

    handleShippingResponse(data) {
      if (data.shipping_rates && data.shipping_rates.length > 0) {
        let html = '<h4>Shipping Options:</h4><ul>';
        data.shipping_rates.forEach((rate) => {
          const price = this.formatMoney(rate.price);
          html += `<li>${rate.name}: ${price}</li>`;
        });
        html += '</ul>';
        this.showResponse(html, 'success');
      } else {
        this.showResponse('No shipping rates available for this location.', 'error');
      }
    }

    setLoadingState(isLoading) {
      if (this.submitBtn) {
        this.submitBtn.textContent = isLoading ? 'Calculating...' : 'Calculate Shipping';
        this.submitBtn.disabled = isLoading;
      }
    }

    showResponse(message, type) {
      if (!this.responseElement) return;

      this.responseElement.innerHTML = message;
      this.responseElement.className = `shipping-calculator__response ${type}`;
      this.responseElement.style.display = 'block';

      // Scroll to response
      this.responseElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    formatMoney(amount) {
      // Basit bir formatlama fonksiyonu
      // Daha gelişmiş bir versiyon için Shopify'ın money formatını kullanabilirsiniz
      return '$' + (amount / 100).toFixed(2);
    }
  }
  customElements.define('shipping-calculator', ShippingCalculator);
}
